// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aJDt","content":"styles_content__2hhhq"};